var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Mail01 } from '@diamond-design/icons';
import InputField from '../inputField/InputField';
export const EmailField = (_a) => {
    var { iconLeft } = _a, props = __rest(_a, ["iconLeft"]);
    return (React.createElement(InputField, Object.assign({ placeholder: "steph@example.com", iconLeft: iconLeft || Mail01, type: "email", inputProps: { pattern: '[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$' } }, props)));
};
export default EmailField;
